"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DELETE_MESSAGES_TYPES = exports.CLEAR_ALL = exports.CLEAR_BUILD_MESSAGES = exports.OPEN = exports.APPEND_DETAIL = exports.APPEND_MESSAGE = exports.ADD_MESSAGE = void 0;
exports.ADD_MESSAGE = 'ADD_MESSAGE';
exports.APPEND_MESSAGE = 'APPEND_MESSAGE';
exports.APPEND_DETAIL = 'APPEND_DETAIL';
exports.OPEN = 'OPEN_MESSAGE_MANAGER';
exports.CLEAR_BUILD_MESSAGES = 'CLEAR_BUILD_MESSAGES';
exports.CLEAR_ALL = 'CLEAR_ALL_MESSAGES';
/**Payload type Array<IMessageType> */
exports.DELETE_MESSAGES_TYPES = 'MESSAGE_MANAGER.DELETE_MESSAGES_TYPES';
//# sourceMappingURL=actionTypes.js.map